import React from "react";
import { createRoot } from "react-dom/client";

import ManagerApp from "./app/manager.jsx";
import { ModalProvider } from "./ModalContext.jsx";
const rootElement = document.getElementById("app");
const root = createRoot(rootElement);

root.render(
    <ModalProvider>
        <ManagerApp />
    </ModalProvider>,
);
